import camelcaseKeys from 'camelcase-keys';
import { z } from 'zod';
const quoteFields = {
    id: z.number(),
    their_reference: z.string(),
    valid_to: z.string(),
    link: z.string(),
    is_current: z.boolean()
};
export const QuoteLineDesignSpec = z.object({
    height: z.number(),
    width: z.number(),
    material: z.string(),
    holes: z.object({
        bolt: z.number().positive().optional(),
        custom_cylinder: z.number().positive().optional(),
        rim_cylinder: z.number().positive().optional(),
        '54mm_lockset': z.number().positive().optional(),
        deadbolt_lockset: z.number().positive().optional(),
        custom_lockset: z.number().positive().optional(),
        countersink: z.number().positive().optional(),
        camlock_cylinder: z.number().positive().optional(),
        euro_cylinder: z.number().positive().optional(),
        oval_cylinder: z.number().positive().optional(),
        PN6_lockset: z.number().positive().optional(),
        PD7_lockset: z.number().positive().optional(),
        rectangle: z.number().positive().optional(),
        square: z.number().positive().optional()
    }),
    num_bends: z.number(),
    powder_coating: z.boolean(),
    handing: z.string(),
    thickness: z.string().regex(/^-?\d{0,2}(?:\.\d{0,2})?$/),
    volume: z.string().regex(/^-?\d{0,10}(?:\.\d{0,2})?$/),
    material_name: z.enum([
        '304SS',
        '316SS',
        'aluminium',
        'brass',
        'matte_black',
        'mild_steel',
        'other'
    ]),
    shape: z.enum([
        'rectangular',
        'square',
        'round',
        'kickplate',
        'strike',
        'other'
    ]),
    finish: z.enum([
        'brushed',
        'milled',
        'chequer',
        'propeller',
        'other',
        'none'
    ])
});
export const CreateQuoteInput = z.object({
    their_reference: z.string()
});
export const CreateQuoteOutput = z.object(quoteFields);
export const UpdateQuoteInput = z.object({
    their_reference: z.string()
});
export const UpdateQuoteOutput = z.object(quoteFields);
const quoteLineOutputFields = {
    id: z.number(),
    configuration_id: z.string(),
    quantity: z.number(),
    price_ex: z.string(),
    usage: z.string().optional().nullable(),
    design_spec: QuoteLineDesignSpec,
    configuration_token: z.string(),
    can_update: z.boolean()
};
const quoteLineInputFields = {
    configuration_id: z.string(),
    quantity: z.number(),
    usage: z.string().optional().nullable(),
    design_spec: QuoteLineDesignSpec,
    configuration_read_token: z.string(),
    configuration_write_token: z.string()
};
export const CreateQuoteLineInput = z.object({
    ...quoteLineInputFields,
    step_file: z.instanceof(Blob).nullable(),
    drawing_file: z.instanceof(Blob),
    design_image: z.instanceof(Blob)
});
export const CreateQuoteLineOutput = z.object(quoteLineOutputFields);
export const GetQuoteLineOutput = z.object(quoteLineOutputFields);
export const GetQuoteOutput = z.object({
    ...quoteFields,
    lines: z.array(z.object(quoteLineOutputFields))
});
export const UpdateQuoteLineInput = z.object({
    ...quoteLineInputFields,
    step_file: z.instanceof(Blob).nullable(),
    drawing_file: z.instanceof(Blob),
    design_image: z.instanceof(Blob)
});
export const UpdateQuoteLineOutput = z.object(quoteLineOutputFields);
export const ListQuotesOutput = z.object({
    count: z.number(),
    next: z.string().nullable(),
    previous: z.string().nullable(),
    results: z.array(z.object({
        ...quoteFields,
        link: z.string()
    }))
});
export const toInternalQuoteLine = (quoteLine)=>{
    return {
        ...camelcaseKeys(quoteLine),
        designSpec: {
            ...camelcaseKeys(quoteLine.design_spec),
            holes: camelcaseKeys(quoteLine.design_spec.holes)
        }
    };
};
export const toInternalQuote = (quote)=>{
    return {
        ...camelcaseKeys(quote),
        lines: quote.lines.map(toInternalQuoteLine)
    };
};

//# sourceMappingURL=metalworks-api.types.js.map